import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { legacyOperationsTarget } from './legacy-links';

/**
 * An old link to the fulfilment work — the inbox, the *Görev Kutusu*, the
 * queue screen — replaced by where that work is now, before the page it used
 * to open renders at all (docs/decisions/0091). Every other address renders
 * what it wraps.
 */
export function LegacyOperationsRedirect({ children }: { children?: ReactNode }) {
  const location = useLocation();
  const target = legacyOperationsTarget(location.pathname, location.search);
  if (target) return <Navigate to={target} replace />;
  return <>{children}</>;
}
